module.exports = __webpack_public_path__ + "img/enfermero-categorias.8588935d.svg";